module.exports = __webpack_public_path__ + "static/media/breastSurgery-image1@2x.47965fe5.png";